import React from 'react'
import useAnalyticsContext from 'src/analytics/useAnalyticsContext'
import SidenavContentNavGroup from 'src/components/SidenavContentNavGroup/SidenavContentNavGroup'
import { SidenavContentNavGroupDivider } from 'src/components/SidenavContentNavGroup/SidenavContentNavGroup.style'
import SidenavContentNavItem from 'src/components/SidenavContentNavItem/SidenavContentNavItem'
import { useMainNavItems } from 'src/navigation/sidenav/useMainNavItems'
import { useQueryStatistics } from 'src/queries/statistics/statistics.queries'
import { StatisticsKeys } from 'src/queries/statistics/statistics.queries.constants'

export interface SidenavMainContentProps {
  isSidenavOpen: boolean
}

const SidenavMainContent: React.FC<SidenavMainContentProps> = (
  props,
): React.ReactElement => {
  const { analytics } = useAnalyticsContext()

  // The three stats whose loaded flags gated the nav groups; legacy relied
  // on SidenavWrapper's dispatch to fill them.
  const { results: statisticsResults } = useQueryStatistics({
    statisticsKeys: [
      StatisticsKeys.CreditCardsActiveCanIssueVirtualCardsCount,
      StatisticsKeys.CreditCardsUserOrViewerMeCount,
      StatisticsKeys.CreditCardsSourceCount,
    ] as const,
  })

  const { navGroups } = useMainNavItems({
    isSidenavOpen: props.isSidenavOpen,
    onNotificationClick: (): void => {
      analytics?.track('home - view notification list - button press', {
        screen: '/home',
        interaction: 'button press',
        intent: 'view notification list',
      })
    },
    onActivityClick: (): void => {
      analytics?.track('home - view activity page - button press', {
        screen: '/home',
        interaction: 'button press',
        intent: 'view activity page',
      })
    },
  })

  return (
    <>
      {statisticsResults[StatisticsKeys.CreditCardsActiveCanIssueVirtualCardsCount]
        .isSuccess &&
        statisticsResults[StatisticsKeys.CreditCardsUserOrViewerMeCount]
          .isSuccess &&
        statisticsResults[StatisticsKeys.CreditCardsSourceCount].isSuccess &&
        navGroups.map((group, groupIndex) => {
          if (!group.condition) return null

          return (
            <React.Fragment key={groupIndex}>
              {group.showDivider && <SidenavContentNavGroupDivider />}
              <SidenavContentNavGroup isSidenavOpen={props.isSidenavOpen}>
                {group.items.map((item) => (
                  <SidenavContentNavItem
                    key={item.id}
                    isSidenavOpen={props.isSidenavOpen}
                    id={item.id}
                    isActive={item.isActive}
                    to={item.to}
                    onClick={item.onClick}
                    ActiveSvg={item.activeSvg}
                    InactiveSvg={item.inactiveSvg}
                    label={item.label}
                    expandOptions={item.expandOptions}
                    notificationsCount={item.notificationsCount}
                  />
                ))}
              </SidenavContentNavGroup>
            </React.Fragment>
          )
        })}
    </>
  )
}

export default SidenavMainContent
